import React from 'react';
// Bootstrap
import { Modal, Button, Nav, Row, Col } from 'react-bootstrap';

// React Router
import { withRouter } from 'react-router-dom'

// Styles
import './modal.scss';

// Font Awesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons'

// Cytoscape
import CytoscapeComponent from 'react-cytoscapejs';
import cytoscape from 'cytoscape';
import euler from 'cytoscape-euler';

// React Select
import Select from 'react-select'

// Project imports
import userGray from '../../assets/userGray.png';

// Loading Overlay
import LoadingOverlay from 'react-loading-overlay';

/* Imports */
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import * as am4plugins_forceDirected from "@amcharts/amcharts4/plugins/forceDirected"; 

// Redux
import { connect } from "react-redux";

// Axios
import axios from 'axios';

cytoscape.use(euler);

const mapStateToProps = state => {
  return {
    investigatorProfile: state.investigatorProfile,
    tabConnectionsOpened: state.tabConnectionsOpened,
    tabActive: state.tabActive,
  };
};


function NodeDetail(props) {

  return (
    <div style={{ fontSize: '14px', color: "#000000" }}>
      <div style={{ fontSize: '18px', color: "#337ab7" }}>
        <a href={props.data.link} style={{color: "#337ab7"}}>{props.data.label}</a>
      </div>
      <div className="mt-2">{props.data.affiliation}</div>
      <div className="mt-2">All ({props.data.all})</div>
      <div>Trials ({props.data.clinicalTrials})</div>
      <div>Events ({props.data.events})</div>
      <div>Publications ({props.data.publications})</div>
      <div>Affiliations (past) ({props.data.institutionsPast})</div>
      <div>Affiliations (present) ({props.data.institutionsPresent})</div>
    </div>
  );
}


export const connectionStregnthOptions = [  
  { value: 'all', label: 'All'},
  { value: '2', label: '2'},
  { value: '3', label: '3'},
  { value: '4', label: '4'},
  { value: '5', label: '5'},
  { value: '6', label: '6'},
  { value: '7', label: '7'},
];


const connectionTypeOptions = [  
  { value: 'all', label: 'All'},
  { value: 'number_clinical_trials', label: 'Trials'},
  { value: 'number_events', label: 'Events'},
  { value: 'number_publications', label: 'Publications'},
  { value: 'number_institutions_past', label: 'Affiliations (past)'},
  { value: 'number_institutions_present', label: 'Affiliations (present)'},
];


const TAB = { NETWORK: 1, PROFILES: 2, RELOADED: 3 }
class PanelConnections extends React.Component {

  constructor(props) {
    super(props)

    // generate yearRange
    const init = 1990;
    const end = (new Date()).getFullYear();
    let yearList = [...Array(end-init).keys()].map(i => i + init)
    yearList = yearList.map( x => {return {label: x, value: x}})


    this.state = {
      isOpened: false,
      activeTab: TAB.NETWORK,
      modalNetwork: undefined,
      users: [],
      connections: [],
      usersFiltered: [],
      connectionsFiltered: [],
      yearList: yearList,
      countryList: [],
      countrySelected: [],
      connectionTypeSelected: [connectionTypeOptions[0]],
      filters: {
        yearFrom: 1990,
        yearTo: (new Date()).getFullYear(),
        strength: 'all',
        connectionTypeList: ['all'],
        countryList: ['all']
      },
      cytoscapeInvestigator: {
        id: '', 
        label: '', 
        medical_expert_oid: '',
        affiliation: '', 
        image: '', 
        strength: '',
        common_project: '',
        all : 0, 
        clicalTrials: 0, 
        events: 0,
        publications: 0, 
        institutionsPast: 0, 
        institutionsPresent: 0
      },
      showFilterSideModal: false,
      showDetailSideModal: false,

      colorList: [        
        { code: "#73a3d9", label: ''}, 
        { code: "#2c74c6", label: ''},
        { code: "#0d3d73", label: ''},
        { code: "#041426", label: ''},
      ],
      cytoscapeReady: false,
      strengthValue: connectionStregnthOptions[0]
    }
    this.cytoscapeMax = undefined
    this.cytoscapeStylesheet = [
      {
        selector: 'node',
        css: {
          'height': 10,
          'width': 10,
          'background-color': 'data(background_color)',
          'border-color': 'data(border_color)',
          'border-width': 1,
          'border-opacity': 0.5,
          //'background-image': 'data(image)',
          'background-width': '60%',
          'background-height': '60%',
          'label': 'data(label)',
          'font-size': 6,
          'color': 'gray',
          'font-weight': 'data(font_weight)'
        }
      },
      {
        selector: 'edge',
        css: { 'line-color': 'data(color)', 'width': 1, }
      },
      {
        selector: 'node:selected',
        css: {
          'height': 14,
          'width': 14,
          'background-color': 'data(background_color)',
          'border-color': 'data(border_color)',
          'border-width': 1,
          'border-opacity': 0.5,
          //'background-image': 'https://demo.explicatos.com/img/user.png',
          'background-width': '60%',
          'background-height': '60%',
          'label': 'data(label)',
          'font-size': 14,
          'z-index': 10,
          "text-background-opacity": 1, 
          "text-background-color": "#ffffff",
          'font-weight': 'data(font_weight)'
        }
      }
    ]
    this.cytoscapeLayout = {
      name: 'euler',
      randomize: true,
      animate: false,
    }

    // const colorList = [        
    //   "#041426",
    //   "#08284d",
    //   "#0d3d73",      
    //   "#11519a",
    //   "#1565c0",

    //   "#2c74c6",
    //   "#4484cd",
    //   "#5b93d3",
    //   "#73a3d9",
    //   "#8ab2e0",
    // ]


  }

  generateProfiles() {
    const { usersFiltered } = this.state;
    // remove first user
    const usersLocal = usersFiltered.slice(1);

    return (
      <div className="h-100 w-100" style={{ position: 'relative'}}>
        <div className="h-100 w-100 d-flex flex-wrap" style={{ position:'absolute', overflowY: 'scroll' }}>
          {usersLocal.map((item, id) =>
            <div key={id} style={{ width: "33%", padding: '1em' }}>
              {item.common_project?
                <a href={item.link} target="_blank" style={{ fontSize: '18px', color: "#337ab7" }} >
                  <b>{item.label}</b>
                </a>                
                :
                <p style={{ fontSize: '18px', color: "#337ab7" }}>{item.label}</p>
              }
              <p style={{ fontSize: '14px' }}>{item.affiliation}</p>

            </div>
          )}
        </div>
      </div>);
 
  }

  renderedCytoscape(cy){
    this.cy = cy
    const that = this;
    this.cy.removeAllListeners()
    this.cy.on('select', 'node', function (evt) {
      evt.preventDefault()
      var data = evt.target[0].data();
      that.setState({cytoscapeInvestigator:data})
    });

    // Requires relayout when filtering
    if( this.state.cytoscapeReady )
      this.cy.layout(this.cytoscapeLayout).run() 


    //cy.userZoomingEnabled( false )
    this.cy.ready( () => {
      that.setState({cytoscapeReady: true})
      this.endTime = Date.now()
    })
  }

  getIntersection(a, b){
    return new Set([...a].filter(x => b.has(x)));
  }

  getFiltering(users, connections){

    const { filters } = this.state;

    // Initialise filtered connections/users
    let filteredUsers = users.map(x => Object.assign({}, x))
    let connectionsIdList = connections.map(x => x.id)    
    
    let filteredStrengthConnectionSet = new Set(connectionsIdList)
    // Filtering Strength
    if( filters.strength !== 'all' ){
      filteredStrengthConnectionSet = new Set()
      for(const connection of connections){

        // Equal number_objects
        if ( parseInt( filters.strength) <= connection.number_objects ) {
          filteredStrengthConnectionSet.add(connection.id);
        }
      }
    }

    
    // Country    
    let filteredCountryConnectionSet = new Set(connectionsIdList)
    if ( filters.countryList.includes('all') === false ) {
      filteredCountryConnectionSet = new Set()   
      // Iterate on connections
      for(const connection of connections){
          if(filters.countryList.includes( connection.country_name) )
            filteredCountryConnectionSet.add(connection.id);            
      }
    }

    // ConnectionType
    let filteredConnectionTypeConnectionSet = new Set(connectionsIdList)
    if ( filters.connectionTypeList.includes('all') === false ) {
      filteredConnectionTypeConnectionSet = new Set()
      // Iterate on connections
      for(const connection of connections){
        // Iterate on connectionType
        for( const connectionType of filters.connectionTypeList ) {
          if( connection[connectionType] > 0 ){
            filteredConnectionTypeConnectionSet.add(connection.id);          
          }          
            
        } // End for connection Type

      } // End For connections
    }


    // Years
    const yearFrom = filters.yearFrom;
    const yearTo = filters.yearTo;

    const checkEventsDate = filters.connectionTypeList.includes('number_events')
    const checkTrialsDate = filters.connectionTypeList.includes('number_clinical_trials')
    const checkPublicationDate = filters.connectionTypeList.includes('number_publications')
    let filteredYearsSet = new Set(connectionsIdList)
    if(checkEventsDate || checkTrialsDate || checkPublicationDate){
      filteredYearsSet = new Set()
      for(const connection of connections){
        if(checkEventsDate){
          const { first_year_common_events, last_year_common_events } = connection;
          if( first_year_common_events < yearFrom || yearTo < last_year_common_events ){
            // Do nothing
          }else{
            filteredYearsSet.add(connection.id);
          }
        }
        if(checkTrialsDate){
          const { first_year_common_clinical_trials, last_year_common_clinical_trials } = connection;         
          if( first_year_common_clinical_trials < yearFrom || yearTo < last_year_common_clinical_trials ){
            // Do nothing
          }else{
            filteredYearsSet.add(connection.id);
          }
        }
        if(checkPublicationDate){
          const { first_year_common_publications, last_year_common_publications } = connection;
          if( first_year_common_publications < yearFrom || yearTo < last_year_common_publications  ){
            // Do nothing
          }else{
            filteredYearsSet.add(connection.id);
          }
        }
      }
    }

    // Get Ids intersection
    let intersection = this.getIntersection(filteredStrengthConnectionSet, filteredCountryConnectionSet)
    intersection = this.getIntersection(intersection, filteredConnectionTypeConnectionSet)
    intersection = this.getIntersection(intersection, filteredYearsSet)

    const filteredConnections = connections.filter( x => intersection.has(x.id) )

    // Fitering user using connections
    filteredUsers = []
    for(const user of users){
      if( filteredConnections.filter( x => x.source == user.id || x.target == user.id).length > 0 ){
        filteredUsers.push(user)
      }
    }

    return {
      users: filteredUsers,
      connections: filteredConnections,
    }
  }


  updateCytoscape(){
    const { users, connections } = this.state;
    const filtering = this.getFiltering(users, connections)

    // Only for mobile
    this.state.showFilterSideModal = false;

    // Force cytoscapeMax to reload
    this.cytoscapeMax = undefined;
    this.setState({ usersFiltered: filtering.users, connectionsFiltered: filtering.connections})
  }

  onFilterConnectionStrength(e){
    this.setState({strengthValue: e.value})
    this.state.filters.strength = e.value
    this.updateCytoscape()
  }

  onFilterCountry(e){
    // If all and some other remove all
    if( e.filter( x => x.value == 'all').length > 0 && e.length > 1){
      e = e.filter( x =>  x.value !== 'all')
    }
    // If none set all
    if( e.length == 0 ){
      e = [this.state.countryList[0]]
    }
    this.state.countrySelected = e
    this.state.filters.countryList = e.map( x => x.value )

    this.updateCytoscape()
  }

  onFilterConnectionType(e){
    // If all and some other remove all
    if( e.filter( x => x.value == 'all').length > 0 && e.length > 1){
      e = e.filter( x =>  x.value !== 'all')
    }
    // If none set all
    if( e.length == 0 ){
      e = [this.state.countryList[0]]
    }
    this.state.connectionTypeSelected = e
    this.state.filters.connectionTypeList = e.map( x => x.value )

    this.updateCytoscape()
  }

  onYearFrom(e){
    this.state.filters.yearFrom = e.value
    this.updateCytoscape()
  }

  onYearTo(e){
    this.state.filters.yearTo = e.value
    this.updateCytoscape()
  }

  isValid(value) {
    return (value != null && value.trim().length > 0);
  }

  get_affiliation(item) {
    let affiliation = '';
    if (this.isValid(item.parent_name)) {
        affiliation += item.parent_name;
    }

    if (this.isValid(item.department) || this.isValid(item.division)) {
        affiliation += ', '
        if (this.isValid(item.department) && this.isValid(item.division)) {
            affiliation += item.department + ' - ' + item.division;
        } else if (this.isValid(item.department)) {
            affiliation += item.department;
        } else {
            affiliation += item.division
        }
    }
    return affiliation;
  }

  async retrieveConnections(){
    try{

      const token = localStorage.getItem('token')
  
      const { match: { params } } = this.props;
      let investigatorId = params.subid;
      investigatorId = investigatorId.split('-')[investigatorId.split('-').length -1 ]
      investigatorId = parseInt( investigatorId )
      let projectOid = params.id;

      // Perform request
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/investigator/${investigatorId}/connections/?affiliations=true`,
        { headers: { "Authorization": "jwt " + token }
      })      
      this.responseConnections = response;

      const countrySet = new Set()

      // collection of nodes
      const investigator_img = {userGray};
      const users = [
        { 
          id: "1", 
          label: this.props.investigatorProfile.name, 
          affiliation: this.props.investigatorProfile.affiliationInstitution,
          image: this.props.picture || investigator_img, 
          strength: '',
          link: `/dashboard/project/${params.id}/investigator/${params.subid}`
        }
      ];      

      let connections = [];
      for(const [idx, item] of Object.entries(response.data.results) ){
                
        // Get data
        const middle_name = (this.isValid(item.middle_name))?item.middle_name:'';
        const combined_name = `${item.first_name} ${middle_name} ${item.last_name}`
        const affiliation = this.get_affiliation(item)


        // prevent adding the node if for some reason, a medical expert is connected more than once
        const user = {
            id: (idx+2), 
            label: combined_name, 
            affiliation: affiliation, 
            image: investigator_img, 
            strength: item.number_common_objects,
            common_project: item.common_project,
            link: `/dashboard/project/${projectOid}/investigator/${item.medical_expert_oid}`,
            background_color: (item.number_common_objects > 7?'#284f91':'#FFFFFF'),
            border_color: (item.number_common_objects > 7?'#284f91':'#4283f1'),
            font_weight: (item.number_common_objects > 7?'bold':'initial'),
        }
        users.push(user);

        
        connections.push({           
          id: 1 + '_' + user.id,
          source: 1, 

          target: user.id, 
          targetExtended: user, 
          strength: item.number_common_objects,
          number_events: item.number_common_events,
          first_year_common_events: item.first_year_common_events,
          last_year_common_events: item.last_year_common_events,
          number_clinical_trials: item.number_common_clinical_trials,
          first_year_common_clinical_trials: item.first_year_common_clinical_trials,
          last_year_common_clinical_trials: item.last_year_common_clinical_trials,
          number_publications: item.number_common_publications,
          first_year_common_publications: item.first_year_common_publications,
          last_year_common_publications: item.last_year_common_publications,
          number_institutions_past: item.numaber_common_institutions_past,
          number_institutions_present: item.number_common_institutions_present,
          number_objects: item.number_common_objects, 
          country_name: item.country_name,
          color: (item.number_objects < 7?'lightgray':'#4283f1')
        }); 

        if(item.country_name)
          countrySet.add(item.country_name)
      }

      // For panel cytoscape
      this.state.users = users
      this.state.connections = connections
      // For maximised cytoscape
      this.state.usersFiltered = users
      this.state.connectionsFiltered = connections

      this.state.cytoscapeInvestigator = users[0]

      // Append countries
      const countryList = [{value:'all', label: 'All'}]
      for( const country of countrySet )
        countryList.push({label: country, value: country})
      const countrySelected = [ countryList[0] ]

      // Initialise countries
      this.setState({ countryList: countryList, countrySelected:countrySelected} )


      // Filter by 5 on start - conditionally
      const hasUserWithStrengthMoreThan5 = connections.some( item => (item.number_objects >=5) )
      if( hasUserWithStrengthMoreThan5 ){
        this.setState({ strengthValue: connectionStregnthOptions[4] })
        this.state.filters.strength = 5
        this.updateCytoscape()
      }

    }catch(error){
      console.log("FAILED")
    }
  }
  
  async componentDidMount(){
    if( this.state.users.length == 0 && this.props.investigatorProfile){
      this.retrieveConnections()      
    }
      
  }

  componentDidUpdate(){
    if( this.state.users.length == 0 && this.props.investigatorProfile)
      this.retrieveConnections()
  }

  generateSource(users, connections){
        
    const source = []
    for (const user of users) {
      const obj = { grabbable: false, data: user}
      source.push(obj)
    }
    for(const connection of connections){
      const obj = { grabbable: false, data: connection}
      source.push(obj)
    }
    return source
  }


  getNodeDesc(id) {

    const { connectionsFiltered } = this.state;

    // Calculate figures
    let clinicalTrials = 0;
    let events = 0;
    let publications = 0;
    let institutionsPast = 0;
    let institutionsPresent = 0;
    let connectionList = connectionsFiltered;

    if (id !== "1" )            
      connectionList = [connectionsFiltered.find(p => ((p.source == "1") && (p.target == id)))];
    for(const connection of connectionList){
      clinicalTrials += connection.number_clinical_trials || 0;
      events += connection.number_events || 0;
      publications += connection.number_publications || 0;
      institutionsPast += connection.number_institutions_past || 0;
      institutionsPresent += connection.number_institutions_present || 0;
    }
    let all = clinicalTrials + events + publications + 
                institutionsPast + institutionsPresent;
    return{
      all, clinicalTrials, events,
      publications, institutionsPast, institutionsPresent
    };
  }

  // generateNetworkChart(){
  //   this.chart = am4core.create("connectionschart", am4plugins_forceDirected.ForceDirectedTree);
  //   // Enable zoom
  //   this.chart.zoomable = true;
  //   // Disable draggable
  //   //this.chart.seriesContainer.draggable = false;

  //   // Create chart series
  //   let networkSeries = this.chart.series.push(new am4plugins_forceDirected.ForceDirectedSeries())
  //   networkSeries.dataFields.linkWith = "linkWith";
  //   networkSeries.dataFields.name = "name";
  //   networkSeries.dataFields.id = "id";
  //   networkSeries.dataFields.value = "value";
  //   networkSeries.dataFields.children = "children";
  //   networkSeries.dataFields.fixed = "fixed";  
  //   networkSeries.dataFields.color = "color";
  //   networkSeries.fontSize = 20;
  //   networkSeries.minRadius = 10;
  //   networkSeries.maxRadius = 10;

  //   networkSeries.nodes.template.propertyFields.x = "x";
  //   networkSeries.nodes.template.propertyFields.y = "y";

    
  //   networkSeries.nodes.template.label.text = "{name}"
  //   //networkSeries.nodes.template.label.text = ""
  //   networkSeries.links.template.distance = 2;



  //   networkSeries.manyBodyStrength = -20;
  //   networkSeries.fontSize = 8;
  //   networkSeries.linkWithStrength = 0;
  //   networkSeries.nodes.template.togglable = false;

  //   let nodeTemplate = networkSeries.nodes.template;
  //   nodeTemplate.tooltipText = "{name}"
  //   nodeTemplate.fillOpacity = 1;
  //   nodeTemplate.label.hideOversized = true;
  //   nodeTemplate.label.truncate = true;



  //   const centerX = 50;
  //   const centerY = 50;
  //   const radius = 5;
  //   let nItemsPerCircle = 8;
  //   let nCircle = 1;

  //   const { usersFiltered, connectionsFiltered, colorList } = this.state;

  //   connectionsFiltered.sort( (a,b) => (a.strength > b.strength) ? 1 : ((b.strength > a.strength) ? -1 : 0) )
  //   connectionsFiltered.reverse()

  //   const maxStrength = connectionsFiltered[0].strength;
  //   let children  = []
  //   let idx = 0;
  //   while(idx < connectionsFiltered.length){
      
  //     const initIdx = idx;
  //     // Check whether not enough pending nodes to fill full circle
  //     const lastCirle = nItemsPerCircle + idx > connectionsFiltered.length;
  //     const endIdx = lastCirle?connectionsFiltered.length:nItemsPerCircle + idx;
  //     const nItemsPerCircleLocal = lastCirle?endIdx-initIdx:nItemsPerCircle;
  //     const connectionsInCirle = connectionsFiltered.slice(initIdx, endIdx);
      

  //     for(const [innerIdx, connection] of connectionsInCirle.entries()){
  //       let x = (centerX + radius * nCircle * Math.cos(2 * Math.PI * innerIdx / nItemsPerCircleLocal) );
  //       let y = (centerY + radius * nCircle * Math.sin(2 * Math.PI * innerIdx / nItemsPerCircleLocal) );

  //       const colorIdx = Math.floor ( ( connection.strength * colorList.length - 1 ) / maxStrength );
  //       let color = colorList[colorIdx]
  //       children.push({
  //         uuid: connection.targetExtended.id, 
  //         id: connection.targetExtended.id, 
  //         name: connection.targetExtended.label,
  //         distance: 1,
  //         fixed: true,
  //         value: 1,
  //         x: am4core.percent(x),
  //         y: am4core.percent(y),    
  //         color: color.code
  //       })
  //     }
  //     idx = idx + nItemsPerCircle;

  //     nCircle++;
  //     nItemsPerCircle = nItemsPerCircle*1.3;

  //   } // End While


  //   networkSeries.data = [  
  //     {  
  //       uuid: usersFiltered[0].id, 
  //       id: usersFiltered[0].id, 
  //       name: usersFiltered[0].label,
  //       children: children,
  //       fixed: true,
  //       value: 1,
  //       x: am4core.percent(centerX),
  //       y: am4core.percent(centerY),  
  //       color: "#0f6086" 
  //     },        
  //   ];

    

  //   // Handler for click on node
  //   const that = this;
  //   networkSeries.nodes.template.events.on("hit", function(event) {
  //     const targetId = event.target.dataItem.id
  //     const test = usersFiltered.filter( item => item.id == targetId )[0]
  //     that.setState({cytoscapeInvestigator:test})
  //   });
    
  //   const step = maxStrength / colorList.length;
  //   for(const [idx, color] of colorList.entries()){
  //     if( idx === 0 ) color.label = `0-${step}`
  //     else if( idx === color.length -1 ) color.label = `${step*idx}-${maxStrength}`
  //     else color.label = `${step*idx}-${step*(idx+1)} `
      
  //   }
  // }

  clearFilters(){
    this.state.filters.strength = 'all';
    this.state.filters.connectionTypeList = ['all']
    this.state.filters.countryList = ['all']
    this.updateCytoscape()
  }

  renderFilters(){
    const { activeTab, countryList, yearList } = this.state;
    const { countrySelected, connectionTypeSelected } = this.state;
    return (
      <>
        <div className="font-weight-bold">Minimum Connection Strength</div>
        <Select
          options={connectionStregnthOptions}
          value={this.state.strengthValue}
          onChange={(e) => this.onFilterConnectionStrength(e)}
        />
        <div className="font-weight-bold">Country</div>
        <Select
          isMulti
          options={countryList}
          value={countrySelected}
          onChange={(e) => this.onFilterCountry(e)}
        />

        <div className="font-weight-bold">Connection Type</div>
        <Select
          isMulti
          options={connectionTypeOptions}
          value={connectionTypeSelected}
          onChange={(e) => this.onFilterConnectionType(e)}
        />
        <div className="d-flex">
          <div className="w-50 mr-1">
            <div className="font-weight-bold">From</div>
            <Select options={yearList}
              onChange={(e) => this.onYearFrom(e)}
              defaultValue={yearList[0]} />
          </div>
          <div className="w-50 ml-1">
            <div className="font-weight-bold">To</div>
            <Select options={yearList}
              onChange={(e) => this.onYearTo(e)}
              defaultValue={yearList[yearList.length - 1]} />
          </div>
        </div>
      </>
    )
  }

  renderDesktop() {
    this.initTime = Date.now()        

    const { usersFiltered, connectionsFiltered, colorList } = this.state;
    const source = this.generateSource(usersFiltered, connectionsFiltered)        
    
    if ( this.cytoscapeMax === undefined && source.length > 0) {

        
        this.cytoscapeMax = <CytoscapeComponent key={this.childKey}
                                elements={source}
                                cy={(cy) => this.renderedCytoscape(cy) }
                                style={{ width: '100%', height: '100%' }}
                                stylesheet={this.cytoscapeStylesheet}
                                layout={this.cytoscapeLayout} />;  
        // Generate connections
        //this.generateNetworkChart()
    }


    const { activeTab } = this.state;
    const { cytoscapeInvestigator } = this.state;    

    let content = undefined;
    switch(activeTab){
      case TAB.NETWORK: content = this.cytoscapeMax; break;
      case TAB.PROFILES: content = this.generateProfiles(); break;
      case TAB.RELOADED: break;
    }

    // Calculate nodeData
    let nodeDesc = {}
    if( cytoscapeInvestigator.id !== '' )
      nodeDesc = this.getNodeDesc(cytoscapeInvestigator.id)
    const nodeData = { ...cytoscapeInvestigator, ...nodeDesc}

    return (
      <div className="d-flex" style={{ height: '100%', alignItems: 'stretch' }}>

            
        <div style={{ width: '30%' }}>
          <div>
            <div className="font-weight-bold p-2 " style={{ fontSize: '16px' }}>FILTERS</div>
            <div className="p-2" style={{ color: '#555' }}>
              {this.renderFilters()}              
            </div>
          </div>
          <div className="mt-3">
          <div className="font-weight-bold pl-2 " style={{ fontSize: '16px' }}>FILTERS</div>
            <div className="pt-2 pl-2" style={{ color: '#555' }}>
              <NodeDetail data={nodeData} />
            </div>
          </div>
        </div>

        <div className="ml-3 d-flex w-100" 
          style={{ flexDirection: 'column', overflow: 'hidden' }}>
          <Nav variant="tabs" style={{ width: '100%' }}>
            <Nav.Item>
              <Nav.Link href="#" active={activeTab == TAB.NETWORK}
                onClick={(e) => this.setState({ activeTab: TAB.NETWORK })}><b>Network</b></Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link href="#" active={activeTab == TAB.PROFILES}
                onClick={(e) => this.setState({ activeTab: TAB.PROFILES })}><b>Profiles</b></Nav.Link>
            </Nav.Item>
            <Nav.Item className="d-none">
              <Nav.Link href="#" active={activeTab == TAB.RELOADED}
                onClick={(e) => this.setState({ activeTab: TAB.RELOADED })}><b>Reloaded</b></Nav.Link>
            </Nav.Item>
          </Nav>

            <LoadingOverlay
              active={this.state.cytoscapeReady === false}
              spinner
              className="d-flex h-100 w-100" style={{ color: 'blue', background: 'yellow'}}> 
              {content}
            </LoadingOverlay>


          <div className={activeTab===TAB.RELOADED?'h-100':'d-none'}>
            <div className="d-flex flex-column"></div>
            <div id="connectionschart" className="w-100" style={{ height: '85%'}}></div> 
            <div className="text-center w-100 font-weight-bold">Number of Connections</div>
            <div className="d-flex justify-content-center" style={{ height: '15%'}}>
              
              
              {colorList.map( (item, id) => 
                <React.Fragment key={id}>
                      <svg height="50" width="50">
                      <circle cx="25" cy="25" r="10" stroke="black" strokeWidth="0" fill={item.code} />
                    </svg>
                    <div style={{ lineHeight: '50px'}}>{item.label}</div>
                </React.Fragment>
              )}
            </div>
          </div>
        </div>

      </div>);
  }

  renderMobile(){
    const { usersFiltered, connectionsFiltered, cytoscapeInvestigator } = this.state;
    const { showFilterSideModal, showDetailSideModal } = this.state;
    const source = this.generateSource(usersFiltered, connectionsFiltered)        
    if ( this.cytoscapeMax === undefined && source.length > 0) {
        this.cytoscapeMax = <CytoscapeComponent key={this.childKey}
                                elements={source}
                                cy={(cy) => this.renderedCytoscape(cy) }
                                style={{ width: '100%', height: '100%' }}
                                stylesheet={this.cytoscapeStylesheet}
                                layout={this.cytoscapeLayout} />;  
        // Generate connections
        //this.generateNetworkChart()
    }

    // Calculate nodeData
    let nodeDesc = {}
    if( cytoscapeInvestigator.id !== '' )
      nodeDesc = this.getNodeDesc(cytoscapeInvestigator.id)
    const nodeData = { ...cytoscapeInvestigator, ...nodeDesc}

    return (
      <div className="w-100">

        <div className={showFilterSideModal ? "inspire-sidemodal-wrapper toggled": "inspire-sidemodal-wrapper"}>
            <div className="p-3">
              <div style={{ fontSize: '20px' }} 
                onClick={(e) => this.setState({ showFilterSideModal: false })}>
                <FontAwesomeIcon icon={faAngleLeft}/>              
              </div>
              <div className="mt-3" style={{ fontSize: '20px' }}>
                <b>Filters</b>  
              </div>
              <div className="mt-3">
                {this.renderFilters()}
              </div>
            </div>
        </div>

        <div className={showDetailSideModal ? "inspire-sidemodal-wrapper toggled": "inspire-sidemodal-wrapper"}>
          <div className="p-3">
            <div style={{ fontSize: '20px' }} 
              onClick={(e) => this.setState({ showDetailSideModal: false })}>
              <FontAwesomeIcon icon={faAngleLeft}/>              
            </div>
            <div className="mt-3" style={{ fontSize: '20px' }}>
              <b>Details</b>  
            </div>
            <div className="mt-3">
              <NodeDetail data={nodeData} />
            </div>
          </div>
        </div>
        

        <div className="d-flex p-3">
          <Button className="mr-1 w-100 inspire-ghost-button no-padding" 
            variant="outline-primary"
            onClick={e => this.setState({showFilterSideModal: true})}>
                Open Filters
          </Button>
          <Button className="ml-1 w-100 inspire-ghost-button no-padding" 
            variant="outline-primary"
            onClick={e => this.setState({showDetailSideModal: true})}>
                See Details
          </Button>          
        </div>
        <div className={window.mobile?"p-3":"d-none"}>
          <Button className="ml-1 w-100 inspire-ghost-button no-padding" 
            variant="outline-primary"
            onClick={e => this.clearFilters()}>
                Clear Filters
          </Button>  
        </div>
        <div style={{ height: '400px'}}>
        {this.cytoscapeMax}
        </div>
      </div>
    )
  }

  render() {
    return (window.mobile?this.renderMobile():this.renderDesktop())
  }
}


export default connect(mapStateToProps, undefined)(withRouter(PanelConnections))
